import { useOutletContext } from "react-router-dom";
import { useEffect } from 'react';
import { APIDisplayNames, APINames, PAGE_TITLE_BASE, PageNames } from '../../Assets/variables';
import { apiInfos } from "../../Assets/API/apiInfos";
import APIPage from "../../Components/APIPage";
import { Helmet } from "react-helmet-async";

const InstrumentDetail = () => {
    const {setActivePageItem} = useOutletContext();
    const apiInfo = apiInfos.filter(apiInfo => apiInfo.apiName === APINames.instrumentDetail)[0];
    
    useEffect(() => {
        setActivePageItem(PageNames.Catalog);
    }, []);
    
    return (
        <>
            <Helmet>
                <title>{`${PAGE_TITLE_BASE}${APIDisplayNames.InstrumentDetail}`}</title>
                <meta name="description" content={`${apiInfo.description}`} />
                <link rel="canonical" href={`/${PageNames.Catalog}/${APINames.instrumentDetail}`} />
            </Helmet>
            <APIPage apiInfo={apiInfo} />
        </>
    );
};

export default InstrumentDetail;